// extracted by mini-css-extract-plugin
export default {"demo":"project_demo__DCUBo","effect":"project_effect__CdMPp"};